import * as authActions from "@rentiohq/shared-frontend/dist/redux/auth/auth.actions";
import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import * as authActionsV2 from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.actions";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { confirm } from "@rentiohq/shared-frontend/dist/utils/confirm.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Button, Loading } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

export const More = () => {
  const dispatch = useDispatch();

  const isRemovingProfile = useSelector((state: IPartialRootState) =>
    authSelectors.isRemovingProfile(state),
  );

  const removeProfileError = useSelector((state: IPartialRootState) =>
    authSelectors.removeProfileError(state),
  );

  const handleUserDelete = async () => {
    confirm({
      type: "error",
      modalProps: {
        hasDismiss: true,
        shouldCloseOnOverlayClick: true,
      },
      info: getLocalizedText("account.delete.confirm"),
      title: getLocalizedText("account.delete.button"),
      primaryActions: [
        {
          title: getLocalizedText("system.no"),
        },
      ],
      secondaryAction: {
        title: getLocalizedText("system.yes"),
        onPress: () => {
          dispatch(
            authActions.removeProfile.actions.start({
              onSuccess: () => dispatch(authActionsV2.signOutStart.getAction()),
            }),
          );
        },
      },
    });
  };

  React.useEffect(() => {
    if (removeProfileError) {
      showAlert({
        message: removeProfileError.message,
        type: "error",
      });
    }
  }, [removeProfileError]);

  if (isRemovingProfile) {
    return <Loading />;
  }

  return (
    <Button appearance="link" onClick={handleUserDelete}>
      {getLocalizedText("profile.delete.button")}
    </Button>
  );
};
